import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { AdminUserProfile } from 'components/DashBoardBlocks';

const Profile: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <AdminUserProfile />
    </Container>
  );
});

export default Profile;
